import Albums from './Albums';
export default Albums;